import { CommonModule } from '@angular/common';
import { CodeInputComponent } from './code-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialDesignModule } from '../material-design.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [CodeInputComponent],
  imports: [CommonModule, TranslateModule, MaterialDesignModule, FormsModule, MatFormFieldModule, MatInputModule],
  exports: [CodeInputComponent],
})
export class CodeInputModule {}
